module.exports = __webpack_public_path__ + "assets/img/disoft-icon.d824c8ce.svg";